import { FadeUp, Lines } from "@/components/motion/Reveal";

export const PageHeader = ({ eyebrow, lines, text, children }) => (
  <section className="pt-32 md:pt-44 pb-12 md:pb-16">
    <div className="container-x">
      <FadeUp><p className="eyebrow mb-5">{eyebrow}</p></FadeUp>
      <Lines as="h1" lines={lines} className="h-display max-w-4xl" data-testid="page-title" />
      {text && <FadeUp delay={0.25} className="lead mt-6 max-w-2xl">{text}</FadeUp>}
      {children}
    </div>
  </section>
);
